var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-facilitate-payment',
                        view: publicPath + 'sprite.svg#view-icon-facilitate-payment',
                        viewBox: '0 0 28 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };